
import { gql } from "@apollo/client";
import { AttentionTypes } from "../../../../Definitions";

export const GET_SYSTEM_INFO = gql`
query SystemInfo($domain: String!, $input: BasicQueryInfoInput!) {
  system {
    info(domain: $domain, input: $input) {
      system_id
      fk_system_types
      name
      feed_balance
      feed_balance_unit
      default_amount
      min_feed_speed
      max_feed_speed
      system_attention_type(domain: $domain)
      programmed
      image
    }
  }
}
`

export interface System {
  system_id: number;
  fk_system_types: number;
  name: string; 
  feed_balance?: number;
  feed_balance_unit?: number;
  default_amount: number;
  min_feed_speed: number;
  max_feed_speed: number;
  system_attention_type: AttentionTypes;
  programmed: number;
  image?: string;
}

export interface SystemsResponse {
  system: {
    info: System[]
  }
}